import loadable from "@loadable/component";
import { ErrorBoundary } from "../../../components";
import FullPageLoader from "@Components/FullPageLoader";
import loadData from "../data";
import useAmberPlusCategories from "../helpers/useAmberPlusCategories";
import NotFound from "@Pages/NotFound";

const PlusCategoriesDesktop = loadable(() => import("./PlusCategoriesDesktop"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => {
  const { isError, isStatus500 } = useAmberPlusCategories(props);

  if (isError) {
    return <NotFound isStatus500={isStatus500} {...props} />;
  }
  return (
    <ErrorBoundary>
      <PlusCategoriesDesktop {...props} />
    </ErrorBoundary>
  );
};
export { loadData };
